module.exports = __webpack_public_path__ + "static/media/Key_PIecesofMind_v2.ba3ced9f.jpg";